import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { ICampaign, ICampaignInput } from "@/interfaces/campaign.interface";
import campaignService from "@/services/campaign.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateCampaignProps = {
  formData: ICampaignInput | FormData;
} & RequestsProps;

export type UseCreateCampaignReturn = {
  create: (props: CreateCampaignProps) => Promise<ICampaign>;
} & UseLoadingReturn;

const useCreateCampaign = (): UseCreateCampaignReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<
    ICampaignInput | FormData
  >({
    operation: (formData) => campaignService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateCampaign;
